
import * as Vue from 'vue';

export default Vue.defineComponent({
  props: {
    totalRounds: Number,
  },
  components: {},
});
